import * as React from "react";
function WarningIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.141 20a.819.819 0 01-.102-.006H3.962a.915.915 0 01-.1.005c-.425 0-.784-.268-.852-.638a.688.688 0 01.13-.54L11.28 4.46c.234-.415.582-.459.72-.459.173 0 .496.06.722.46l8.138 14.362c.251.337.155.799-.217 1.035a.937.937 0 01-.502.143zm-16.29-.838a.326.326 0 01-.033.047.044.044 0 00-.01.037c.004.026.03.042.053.042a.526.526 0 01.075-.006h16.13a.4.4 0 01.065.005h.007a.056.056 0 00.034-.009c.025-.015.03-.046.012-.068a.31.31 0 01-.033-.048l-8.15-14.385-8.15 14.385z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.371c-.222 0-.403-.16-.403-.356v-4.982c0-.196.181-.356.404-.356.222 0 .403.16.403.356v4.982c0 .197-.18.356-.403.356zM12.012 17.15c-.332 0-.603-.227-.615-.516a.505.505 0 01.167-.386.631.631 0 01.422-.165c.342.006.607.233.62.517a.505.505 0 01-.167.387.634.634 0 01-.423.164h-.004z"
  }));
}
const ForwardRef = React.forwardRef(WarningIcon);
export default ForwardRef;